import React, { useState, useEffect } from 'react'
import { Row, Col, Table, Button, Form, Modal, CardImg, Alert } from "react-bootstrap";
import useStateRef from 'react-usestateref';
import { Link,json,useNavigate } from "react-router-dom";
import Card from "../../../../../components/Card";
import swal from 'sweetalert';
//import apiPath from "../../../../../config/apipath";
import apiService from "../../../../../provider/apiService";
import Select from 'react-select';
import "../../../../App.css";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { elementClosest, joinSpans } from '@fullcalendar/react';

const TableData = () => {

 
 const [SaveButtonText, setSaveButtonText] = useState("Save");
 
 
  useEffect(() => {
	
    sessionStorage.getItem("OtherIssue_EditElg")==='true' ?  setDisabled(''):  setDisabled('disabled');

   if(sessionStorage.getItem("OtherIssue_Action")=="Add")
   {
	    setSaveButtonText("Save");
      setBillNo("{Auto}");
     
      //Clear();
   
   }
   else if(sessionStorage.getItem("OtherIssue_Action")=="Edit")
   {
	   setSaveButtonText("Update");
	   Display(sessionStorage.getItem("OtherIssue_EditId"));
   }
   else if(sessionStorage.getItem("OtherIssue_Action")=="Delete")
   {
	   setSaveButtonText("Delete");
	   Display(sessionStorage.getItem("OtherIssue_EditId"));
   }
	
   ControlSettings();
   innitialSetValue();
   

  }, []);
  

  function innitialSetValue() {


  getLookup();
  
  }


  function CustEntryClose()
  {
    setxCustName('');
    setxMobile('');
    setxAddress1('');
    setxAddress2('');
    setxAddress3('');
    setxArea('');
    setxCity('');
    setxPinCode('');
    setxPhoneNo('');
    setxEmailId('');

    CustEntryhandleClose1();

  }
  function CustOpen()
  {
    
    setCustSearchTxt('');
    setdtCust([]);
    setdtCust_Org([]);
    CusthandleShow1();

  
    GetCustList('{'+CustIdRef.current+'}');

    
  }
  const [isDisabled, setisDisabled]=useState(false);
  
  const [dtStProd, setdtStProd]=useState([]);
  const [dtStSubProd, setdtStSubProd]=useState([]);
  const [DtStRecMode, setDtStRecMode]=useState([]);
  
  const [btndisabled, setDisabled] = useState('disabled');

  const [dtProd, setdtProd]=useState([]);
  const [dtSubProd, setdtSubProd]=useState([]);
  const [dtTag, setdtTag]=useState([]);
  const [dtTagInfo, setdtTagInfo]=useState([]);
  const [dtTagList,setdtTagList]=useState([]);

  
  const [dtCust, setdtCust,dtCustRef]=useStateRef([]);
  const [dtCust_Org, setdtCust_Org,dtCust_OrgRef]=useStateRef([]);
  

  const [DtStDetTable, setDtStDetTable, DtStDetTableRef]=useStateRef([]);
  let StDetTable=[];

  const [DtSaleDetTable, setDtSaleDetTable, DtSaleDetTableRef]=useStateRef([]);
  let SaleDetTable=[];

  
  const [Salesshow1, setSalesshow1] = useState(false);
  const SaleshandleClose1 = () => setSalesshow1(false);
  const SaleshandleShow1 = () => setSalesshow1(true);
  
  const [Stoneshow1, setStoneshow1] = useState(false);
  const StonehandleClose1 = () => setStoneshow1(false);
  const StonehandleShow1 = () => setStoneshow1(true);
  
  
  
  const [Custshow1, setCustshow1] = useState(false);
  const CusthandleClose1 = () => setCustshow1(false);
  const CusthandleShow1 = () => setCustshow1(true);
  
  const [CustEntryshow1, setCustEntryshow1] = useState(false);
  const CustEntryhandleClose1 = () => setCustEntryshow1(false);
  const CustEntryhandleShow1 = () => setCustEntryshow1(true);
  
  
   const [BillNo, setBillNo, BillNoRef] = useStateRef(0);
   const [BillDate, setBillDate, BillDateRef] = useStateRef((new Date()).toISOString().substring(0,10));
   


   
//sales Detail
const [SaleId,setSaleId,SaleIdRef]=useStateRef('');
const [ProdName,setProdName,ProdNameRef]=useStateRef('');
const [SubProdName,setSubProdName,SubProdNameRef]=useStateRef('');
const [TagNo,setTagNo,TagNoRef]=useStateRef('');
const [Pcs,setPcs,PcsRef]=useStateRef(0);
const [GrossWt,setGrossWt,GrossWtRef]=useStateRef(0);
const [LessWt,setLessWt,LessWtRef]=useStateRef(0);
const [NetWt,setNetWt,NetWtRef]=useStateRef(0);
const [SalesWt,setSalesWt,SalesWtRef]=useStateRef(0);
const [WasteP,setWasteP,WastePRef]=useStateRef(0);
const [WasteGrm,setWasteGrm,WasteGrmRef]=useStateRef(0);
const [Wastage,setWastage,WastageRef]=useStateRef(0);
const [StoneAmt,setStoneAmt,StoneAmtRef]=useStateRef(0);
const [OthrAmt,setOthrAmt,OthrAmtRef]=useStateRef(0);
const [HMAmt,setHMAmt,HMAmtRef]=useStateRef(0);
const [TotAmt,setTotAmt,TotAmtRef]=useStateRef(0);
const [Rate,setRate,RateRef]=useStateRef(0);
const [TagInfo,setTagInfo,TagInfoRef]=useStateRef('');
const [Amt,setAmt,AmtRef]=useStateRef(0);
const [WasteAmt,setWasteAmt,WasteAmtRef]=useStateRef(0);
const [STaxP,setSTaxP,STaxPRef]=useStateRef(0);
const [STaxAmt,setSTaxAmt,STaxAmtRef]=useStateRef(0);
const [HUIDNo,setHUIDNo,HUIDNoRef]=useStateRef(0);
const [SmithCode,setSmithCode,SmithCodeRef]=useStateRef(0);
const [PcsRate,setPcsRate,PcsRateRef]=useStateRef(0);
const [SaleMode,setSaleMode,SaleModeRef]=useStateRef(0);
const [TagMark,setTagMark,TagMarkRef]=useStateRef("T");

//Stone Details
   const [StProdName,setStProdName,StProdNameRef]=useStateRef('');
   const [StSubProdName,setStSubProdName,StSubProdNameRef]=useStateRef('');
   const [StRecMode,setStRecMode,StRecModeRef]=useStateRef('');
   const [StPcs,setStPcs,StPcsRef]=useStateRef(0);
   const [StWeight,setStWeight,StWeightRef]=useStateRef(0);
   const [StRate,setStRate,StRateRef]=useStateRef(0);
   const [StAmount,setStAmount,StAmountRef]=useStateRef(0);
   const [StId,setStId,StIdRef]=useStateRef(0);


//Customer Details
   const [CustId,setCustId,CustIdRef]=useStateRef(0);
   const [CustName,setCustName,CustNameRef]=useStateRef('');
   const [CustBillName,setCustBillName,CustBillNameRef]=useStateRef('');
   const [CustRelation,setCustRelation,CustRelationRef]=useStateRef('Own');
   
   const [Mobile,setMobile,MobileRef]=useStateRef('');
   const [Address1,setAddress1,Address1Ref]=useStateRef('');
   const [Address2,setAddress2,Address2Ref]=useStateRef('');
   const [Address3,setAddress3,Address3Ref]=useStateRef('');
   const [Area,setArea,AreaRef]=useStateRef('');
   const [City,setCity,CityRef]=useStateRef('');
   const [PinCode,setPinCode,PinCodeRef]=useStateRef('');
   const [PhoneNo,setPhoneNo,PhoneNoRef]=useStateRef('');
   const [EmailId,setEmailId,EmailIdRef]=useStateRef('');
   const [AdharNo,setAdharNo,AdharNoRef]=useStateRef('');
   const [PanNo,setPanNo,PanNoRef]=useStateRef('');
  

   const [xCustId,setxCustId,xCustIdRef]=useStateRef(0);
   const [xCustName,setxCustName,xCustNameRef]=useStateRef('');
   const [xMobile,setxMobile,xMobileRef]=useStateRef('');
   const [xAddress1,setxAddress1,xAddress1Ref]=useStateRef('');
   const [xAddress2,setxAddress2,xAddress2Ref]=useStateRef('');
   const [xAddress3,setxAddress3,xAddress3Ref]=useStateRef('');
   const [xArea,setxArea,xAreaRef]=useStateRef('');
   const [xCity,setxCity,xCityRef]=useStateRef('');
   const [xPinCode,setxPinCode,xPinCodeRef]=useStateRef('');
   const [xPhoneNo,setxPhoneNo,xPhoneNoRef]=useStateRef('');
   const [xEmailId,setxEmailId,xEmailIdRef]=useStateRef('');
   const [xAdharNo,setxAdharNo,xAdharNoRef]=useStateRef('');
   const [xPanNo,setxPanNo,xPanNoRef]=useStateRef('');
   const [xRefMobileNo,setxRefMobileNo,xRefMobileNoRef]=useStateRef('');
   const [xRefCustId,setxRefCustId,xRefCustIdRef]=useStateRef('');
   const [xRefRelation,setxRefRelation,RefxRelationRef]=useStateRef('');
   const [xRefCustName,setxRefCustName,xRefCustNameRef]=useStateRef('');
 
  
   const [CustSearchTxt, setCustSearchTxt, CustSearchTxtRef] = useStateRef('');
   const [dtCustRelation, setdtCustRelation, dtCustRelationRef] = useStateRef([]);
   
   const [ShowCustBillDetail, setShowCustBillDetail, ShowCustBillDetailRef] = useStateRef(true);

   //Bill Details
   const [TSalesWt, setTSalesWt, TSalesWtRef] = useStateRef(0);
   const [SalesAmount, setSalesAmount, SalesAmountRef] = useStateRef(0);
   

   
/*
function SearchFun(text)
{
  setdtGrnDetails(dtGrnDetailsOrg.filter(function (x) {
    return x.No.toLowerCase().indexOf(text.toLowerCase()) > -1;
}))
}  
*/

async function CustEdit(id)
{
  try {

    let postData = {
      "CustId" : id
     };
     
  
    const results = await apiService.postCall("otherissue/custdisplay",postData);
  
    if (results != "-1") {

      setxCustId(results.data[0][0].CustId);
      setxCustName(results.data[0][0].CustomerName)
      setxMobile(results.data[0][0].Mobile)
      setxAddress1(results.data[0][0].Address1)
      setxAddress2(results.data[0][0].Address2)
      setxAddress3(results.data[0][0].Address3)
      setxArea(results.data[0][0].Area)
      setxCity(results.data[0][0].City)
      setxPinCode(results.data[0][0].PinCode)
      setxPhoneNo(results.data[0][0].Phone)
      setxEmailId(results.data[0][0].EmailId)
      setxAdharNo(results.data[0][0].AdharNo)
      setxPanNo(results.data[0][0].PanNo)
      setxRefCustId(results.data[0][0].RefCustId)
      setxRefMobileNo(results.data[0][0].RefMobile)
      setxRefCustName(results.data[0][0].RefCustName)
      setxRefRelation(results.data[0][0].RefRelation)

      

      CustEntryhandleShow1();
     }
  } catch (error) {
       console.log(error);
     }
}

 
function CustSelect(id)
{

  var result = dtCustRef.current.find(obj => {
    return obj.CustId === id
  });
if(result!=undefined)
{

 
  setMobile(result.Mobile);
  setCustName(result.CustomerName);
  setCustId(result.CustId);
  setAddress1(result.Address1);
  setAddress2(result.Address2);
  setAddress3(result.Address3);
  setArea(result.Area);
  setCity(result.City);
  setPinCode(result.PinCode);
  setPhoneNo(result.Phone);
  setEmailId(result.EmailId);
  setPanNo(result.PanNo);
  setAdharNo(result.AdharNo);
 

}
else
{

} 

CusthandleClose1();

}

async function OpenStoneScreen()
{
StonehandleShow1();
}

async function CloseStoneScreen()
{

if((StProdNameRef.current.length>0) || (StSubProdNameRef.current.length>0))
{
  setStProdName("");
  setStSubProdName("");
  setStRecMode(" ");
  setStPcs("");
  setStRate("");
  setStWeight("");
  setStAmount("");
}
else
{

  var i=0;
  let Samt=0;
  for (i = 0; i < DtStDetTableRef.current.length; i++) {

Samt=val(Samt)+val(DtStDetTableRef.current[i].StAmount)

      }
  

  setStoneAmt(Samt);

  Calc();

  setStoneshow1(false);

}

}









   async function SalesClear()
   {
    
    if((ProdNameRef.current.length>0) || (SubProdNameRef.current.length>0)|| (TagInfoRef.current.length>0))
    {
    setProdName('');
    setSubProdName('');
    setTagNo('');
    setTagInfo('');
    setPcs(0);
    setGrossWt(0);
    setNetWt(0);
    setLessWt(0);
    setSalesWt(0);
    setWasteGrm(0);
    setWasteP(0);
    setStoneAmt(0);
    setOthrAmt(0);
    setHMAmt(0);
    setTotAmt(0);
    setSTaxP(0);
    setSTaxAmt(0);
    setHUIDNo('');

  }
  else
  {SaleshandleClose1();
	}
    


	 	
   }

   




function val(value)
{
	value=parseFloat(value);
	if(isNaN(value)==true)
		value=0;
	else
		value=value;
	
	return value;
}

async function BillCalc()
{

  SaleDetTable=DtSaleDetTableRef.current;
  
  var cnt1 = 0;
  try {
    cnt1 = SaleDetTable.length;
  }
  catch (err) {
    cnt1 = 0;
  }
  let i1=0;
  let TSalWtWt=0;
  let TSalAmount1=0;
  let STaxAmount=0;
  let TaxP=0;
  for (i1 = 0; i1 < cnt1; i1++) {
    TSalWtWt=val(TSalWtWt)+val(SaleDetTable[i1].NetWt);
    TSalAmount1=val(TSalAmount1)+val(SaleDetTable[i1].TotAmt);
    STaxAmount=val(STaxAmount)+val(SaleDetTable[i1].STaxAmt);
    TaxP=val(SaleDetTable[i1].STaxP);

  }
  setTSalesWt(TSalWtWt.toFixed(2));
  setSalesAmount(TSalAmount1.toFixed(2));
 


 

          //

          
}


async function Calc()
{
  
  setNetWt(val(GrossWtRef.current)-val(LessWtRef.current));
  setSalesWt(NetWtRef.current);
  setWastage(val(val(SalesWtRef.current)*val(WastePRef.current)/100).toFixed(2));
 
  setAmt((val(SalesWtRef.current)*val(RateRef.current)).toFixed(2));
  let Grm=Math.ceil(val(SalesWtRef.current)/8);  
  let WGrmAmt=val(val(WasteGrmRef.current)*Grm).toFixed(2);
  let WAmt=val(val(WastageRef.current)*val(RateRef.current)).toFixed(2);
  setWasteAmt(val(WGrmAmt)+val(WAmt));

  setTotAmt(val(AmtRef.current)+val(StoneAmtRef.current)+val(HMAmtRef.current)+val(OthrAmtRef.current)+val(WasteAmtRef.current));

  setSTaxAmt(val(val(TotAmtRef.current)*val(STaxPRef.current)/100).toFixed(2));


}


async function ControlSettings()
{

  document.getElementById("txtBillNo").disabled ='true';
  
  
  if((sessionStorage.getItem("OtherIssue_Action")=="Edit") || (sessionStorage.getItem("OtherIssue_Action")=="Delete"))
   {
  
   
    

   }

 



}

async function getxRefName()
{
  try
  {


    setxRefCustId(0);
    setxRefCustName('');

    
if(xRefMobileNoRef.current.length==10)
{
    
    let postData = {
      MobileNo :xRefMobileNoRef.current
  }

 
  const results = await apiService.postCall("otherissue/getcustname",postData);

 if (results != "-1") {


  if(results.data[0].length>0)
  {
  setxRefCustId(results.data[0][0].CustId);
  setxRefCustName(results.data[0][0].CustomerName);
}


}

} 
  }
  catch (error) {
    console.log(error);
  }
}


async function GetCustList(search)
{


  try
  {


    if(search.indexOf('{')==-1)
    {
    if(search.length<5)
    {
   setdtCust([]);
   setdtCust_Org([]);
   return;
    }
  }  
    
    let postData = {
      Search :search
  }

 

  const results = await apiService.postCall("otherissue/getcustlist",postData);

 if (results != "-1") {
   setdtCust(results.data[0]);
   setdtCust_Org(results.data[0]);

   CusthandleShow1();
 }

  
  }
  catch (error) {
    console.log(error);
  }
}


async function Display(EditId){
	  try
    {
     
      let postData = {
        EditId: EditId
    }



  

    const results = await apiService.postCall("otherissue/Display",postData);


   if (results != "-1") {
     
	 let HeadData=results.data.Head;
   let SalesDetail=results.data.SalesDetail;
   let StoneDetail=results.data.StoneDetail;

  
   
  
let StoneArry=[];

   
  if(SalesDetail[0].length>0)
   setDtSaleDetTable(SalesDetail[0]);

  if(StoneDetail[0].length>0)
  StoneArry=StoneDetail[0];


  

 
  
   let i=0;

   SaleDetTable=DtSaleDetTableRef.current;

   for(i=0;i<SaleDetTable.length;i++)
   {
    let headslno=SaleDetTable[i].SlNo;

    let StDetail=StoneArry.filter(function (x) {
      return x.HeadID==headslno;
  });
      
  SaleDetTable[i].StoneDetails=StDetail;


   }

   setDtSaleDetTable(SaleDetTable);

   
      setBillNo(HeadData[0][0].BillNo);
      setBillDate(HeadData[0][0].BillDate);
      setCustId(HeadData[0][0].CustId);
      setCustName(HeadData[0][0].PartyName);
      setCustBillName(HeadData[0][0].PartyName);
      setCustRelation(HeadData[0][0].Relation);
      setMobile(HeadData[0][0].MobileNo);
      setAddress1(HeadData[0][0].Add1);
      setAddress2(HeadData[0][0].Add2);
      setAddress3(HeadData[0][0].Add3);
      setArea(HeadData[0][0].Area);
      setCity(HeadData[0][0].City);
      setPinCode(HeadData[0][0].Pincode);
      setPhoneNo(HeadData[0][0].PhoneNo);
      setEmailId(HeadData[0][0].Email);
      setAdharNo(HeadData[0][0].AdharNo);
      setPanNo(HeadData[0][0].PanNo);
      setTSalesWt(HeadData[0][0].SaleWt);
      setSalesAmount(HeadData[0][0].SalesAmount);
      

   getLookup();



     
     

     
       
   }

    
    }
    catch (error) {
      console.log(error);
    }

  }

  async function CustSave(){
	  try
		{
	
		
			
			if(xCustNameRef.current=="")
      {
 
        swal({

          title: "",
          text: "Please Enter Customer Name",
          icon: "info",
          button: "Ok"
          
        }).then(function () {
          
        });
    
        return;
      }
	
      if(xMobileRef.current=="")
      {
 
        swal({

          title: "",
          text: "Please Enter Mobile",
          icon: "info",
          button: "Ok"
          
        }).then(function () {
          
        });
    
        return;
      }

      
var Action="Add";
if(val(xCustIdRef.current)>0)
  Action="Edit";

		 
		let postData = {
			"Action" : Action,
			"EditId" : xCustId,
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
			"CustName": xCustNameRef.current,
      "MobileNo": xMobileRef.current,
      "Address1": xAddress1Ref.current,
			"Address2": xAddress2Ref.current,
      "Address3": xAddress3Ref.current,
      "Area": xAreaRef.current,
      "City": xCityRef.current,
      "PinCode": xPinCodeRef.current,
      "PhoneNo": xPhoneNoRef.current,
      "EmailId": xEmailIdRef.current,
      "AdharNo": xAdharNoRef.current,
      "PanNo": xPanNoRef.current,
      "RefCustId": xRefCustIdRef.current,
      "RefCustMobileNo": xRefMobileNoRef.current,
      "RefCustName":xRefCustNameRef.current,
      "RefRelation": RefxRelationRef.current,
    }

    

   const results = await apiService.postCall("otherissue/CustSave",postData);


  

   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "Alert",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  
  if(Action=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Customer Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {

     
      setdtCust(results.data[0]);
      setdtCust_Org(results.data[0]);
      
     CustEntryhandleClose1();
    });
	
  }

  else if(Action=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Customer Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {

     
      setdtCust(results.data[0]);
      setdtCust_Org(results.data[0]);

      CustEntryhandleClose1();
    });
	
  }
	 
  else if(Action=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
    CustEntryhandleClose1();
   });
 
 }
	 
      }
    }
    catch (error) {
      console.log(error);
    }

  }
async function Save(){
	  try
		{
	
		
		let postData = {
			"Action" : sessionStorage.getItem("OtherIssue_Action"),
			"EditId" : sessionStorage.getItem("OtherIssue_EditId"),
      "eBranchCode" : sessionStorage.getItem("BranchCode"),
			"FinMinDate": sessionStorage.getItem("FinMinDate"),
			"FinMaxDate": sessionStorage.getItem("FinMaxDate"),
			"EntryUser":sessionStorage.getItem("EntryUser"),
      "BillNo":BillNoRef.current,
      "BillDate":BillDateRef.current,
      "DtSaleDetTable":DtSaleDetTableRef.current,
      "CustId":CustIdRef.current,
      "CustName":CustNameRef.current,
      "CustBillName":CustBillNameRef.current,
      "CustRelation":"Own",
      "Mobile":MobileRef.current,
      "Address1":Address1Ref.current,
      "Address2":Address2Ref.current,
      "Address3":Address3Ref.current,
      "Area":AreaRef.current,
      "City":CityRef.current,
      "PinCode":PinCodeRef.current,
      "PhoneNo":PhoneNoRef.current,
      "EmailId":EmailIdRef.current,
      "AdharNo":AdharNoRef.current,
      "PanNo":PanNoRef.current,
      "TSalesWt":TSalesWtRef.current,
      "SalesAmount":SalesAmountRef.current
      }

    let ErrMsg="";



    if((postData.CustId==undefined)||(postData.CustId==''))
    {
      postData.CustId="0";
    }

    if((postData.EmpId1==undefined)||(postData.EmpId1==''))
    {
      postData.EmpId1="0";
    }

    
    if(postData.DtSaleDetTable.length==0)
    {
      ErrMsg="Please Enter Issue Details";
    }



    if(ErrMsg=="")
    {
    

   const results = await apiService.postCall("otherissue/Save",postData);

   if (results != "-1") {

if(results.errorCode=="8888")
{


  swal({

    title: "",
    text: results.data,
    icon: "info",
    button: "Ok"
    
  }).then(function () {
    
  });

  return;

}  
  if(sessionStorage.getItem("OtherIssue_Action")=="Add")
   {
    swal({

      title: "Success",
      text: "Successfully Add Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }

  else if(sessionStorage.getItem("OtherIssue_Action")=="Edit")
   {
    swal({

      title: "Success",
      text: "Successfully Update Your Details!",
      icon: "success",
      button: "Ok"

    }).then(function () {
      BackToList();
    });
	
  }
	 
  else if(sessionStorage.getItem("OtherIssue_Action")=="Delete")
  {
   swal({

     title: "Success",
     text: "Successfully Delete Your Details!",
     icon: "success",
     button: "Ok"

   }).then(function () {
     BackToList();
   });
 
 }
	 
      }

    }
    else
    {
      swal({

        title: "",
        text: ErrMsg,
        icon: "info",
        button: "Ok"
   
      }).then(function () {
        
      });
    }
    }
    catch (error) {
      console.log(error);
    }

  }


function StCalc()
    {
  let Pcs=val(StPcsRef.current);
  let PcsRate=val(StRateRef.current);
  let StWt=val(StWeightRef.current);
  let StRecMode=(StRecModeRef.current);

  let StoneAmount=0;
  if(StRecMode=="P")
      StoneAmount=val(val(Pcs)*val(PcsRate)).toFixed(2);
  else if(StRecMode=="W") 
      StoneAmount=val(val(PcsRate)*val(StWt)).toFixed(2);
  else if(StRecMode=="C") 
      StoneAmount=val(val(Pcs)*val(StWt)).toFixed(2);
   
      
  setStAmount(StoneAmount);
 
    }


    


    


    async function StgridEdit (id) {

     

      StDetTable=DtStDetTable;

      var cnt = 0;
      try {
          cnt = StDetTable.length;
      }
      catch (err) {
          cnt = 0;
      }

  
  

 
      let i=0;

      for (i = 0; i < cnt; i++) {
          if (StDetTable[i].ID == id) {

              setStId(id);
              setStProdName(StDetTable[i].ProdName);
              setStSubProdName(StDetTable[i].SubProdName);
              setStRecMode(StDetTable[i].RecMode);
              setStPcs(StDetTable[i].Pcs);
              setStRate(StDetTable[i].PcsRate);
              setStWeight(StDetTable[i].StWt);
              setStAmount(StDetTable[i].StAmount);
            

    await getStSubProduct();
    setStSubProdName(StDetTable[i].SubProdName);

              break;

          }          
      }

      setDtStDetTable(StDetTable);
    


  }




async function SalesgridEdit (id) {

     

  SaleDetTable=DtSaleDetTable;

  var cnt = 0;
  try {
      cnt = SaleDetTable.length;
  }
  catch (err) {
      cnt = 0;
  }





  let i=0;

  for (i = 0; i < cnt; i++) {
      if (SaleDetTable[i].ID == id) {


        
        setSaleId(id);
        setProdName(SaleDetTable[i].ProdName);
        setTagNo(SaleDetTable[i].TagNo);
        setSubProdName(SaleDetTable[i].SubProdName);
        setPcs(SaleDetTable[i].Pcs);
        setGrossWt(SaleDetTable[i].GrossWt);
        setLessWt(SaleDetTable[i].LessWt);
        setNetWt(SaleDetTable[i].NetWt);
        setWasteP(SaleDetTable[i].WasteP);
        setWasteGrm(SaleDetTable[i].WasteGrm);
        setRate(SaleDetTable[i].Rate);
        setSalesWt(SaleDetTable[i].SalesWt);
        setStoneAmt(SaleDetTable[i].StoneAmt);
        setHMAmt(SaleDetTable[i].HMAmt);
        setTagInfo(SaleDetTable[i].TagInfoCode);
        setOthrAmt(SaleDetTable[i].OthrAmt);
        setTotAmt(SaleDetTable[i].TotAmt);
        setAmt(SaleDetTable[i].Amt);
        setWasteAmt(SaleDetTable[i].WasteAmt);
        setSTaxP(SaleDetTable[i].STaxP);
        setSTaxAmt(SaleDetTable[i].STaxAmt);
        setHUIDNo(SaleDetTable[i].HUIDNo);
        setSmithCode(SaleDetTable[i].SmithCode);
        setPcsRate(SaleDetTable[i].PcsRate);
        setSaleMode(SaleDetTable[i].SaleMode);
        setTagMark(SaleDetTable[i].TagMark);
     
        setDtStDetTable(SaleDetTable[i].StoneDetails);
        
       
      
          

await getSubProduct(1);

          break;

      }          
  }

  setDtSaleDetTable(SaleDetTable);

  SaleshandleShow1();

}



  function StgridRemove (id) {


    let HeadID=0;

    StDetTable=DtStDetTable;
     
      var cnt = 0;
      try {
          cnt = StDetTable.length;
      }
      catch (err) {
          cnt = 0;
      }
   
    let i=0;

      for (i = 0; i < cnt; i++)
      {
          if ((StDetTable[i].ID == id))
          {
              StDetTable.splice(i, 1);
              break;
          }
      }

      setDtStDetTable(StDetTable);
    
    setStSubProdName("");
    
    
    
    //Clear();

  }


 async function SalegridRemove (id) {


  
    SaleDetTable=DtSaleDetTable;
     
      var cnt = 0;
      try {
          cnt = SaleDetTable.length;
      }
      catch (err) {
          cnt = 0;
      }
   
    let i=0;

      for (i = 0; i < cnt; i++)
      {
          if ((SaleDetTable[i].ID == id))
          {
            SaleDetTable.splice(i, 1);
              break;
          }
      }

      setDtSaleDetTable(SaleDetTable);
    
    setProdName('');
    
    await BillCalc();
    
    //Clear();

  }


  async function StClear()
  {

     setStId(0);
     setStProdName("");
     setStSubProdName("");
     setStRecMode(" ");
     setStPcs("");
     setStRate("");
     setStWeight("");
     setStAmount("");
     
     await getStSubProduct();

       
  }


   
async function StgridAdd () {


  let id=0;
  let slno=StIdRef.current;
  let ProdName=StProdNameRef.current;
  let SubProdName=StSubProdNameRef.current;
  let RecMode=StRecModeRef.current;
  let Pcs=val(StPcsRef.current);
  let PcsRate=val(StRateRef.current);
  let StWt=val(StWeightRef.current);
  let StAmount=val(StAmountRef.current);
  
if ((ProdName.length>0)&&(SubProdName.length>0)&&(Pcs>0)&&(RecMode.length>0))
{
    StDetTable=DtStDetTable;
    var cnt = 0;
    try
    {
        cnt = StDetTable.length;
       
    }
    catch(err)
    {
        cnt=0;
    }



    var found = false;
    var i=0;

    for (i = 0; i < cnt; i++) {



        if ((StDetTable[i].ID == slno)) {


          StDetTable[i].ProdName=ProdName;
          StDetTable[i].SubProdName=SubProdName;
          StDetTable[i].RecMode=RecMode;
          StDetTable[i].Pcs=Pcs;
          StDetTable[i].PcsRate=PcsRate;
          StDetTable[i].StWt=StWt;
          StDetTable[i].StAmount=StAmount;
           
           
            //det text box clear

          StClear();


            found = true;
            break;
        }
        else {


            if ((StDetTable[i].ProdName == ProdName) && (StDetTable[i].SubProdName == SubProdName) && (StDetTable[i].HeadID == id) && (parseFloat(StDetTable[i].Pcs).toFixed(3) == parseFloat(Pcs).toFixed(3))) {
                swal({
        title: "",
        text: "Already Found",
        icon: "info",
        button: "Ok"

        });

                found = true;
                break;

            }
        }
    }


    if (found == false) {

        var row = {
            "ID": parseInt(cnt) + 1
            ,"HeadID": SaleIdRef.current
            , "ProdName":ProdName
            , "SubProdName":SubProdName
            , "RecMode":RecMode
            , "Pcs":Pcs
            , "PcsRate":PcsRate
            , "StWt":StWt
            , "StAmount":StAmount
        };

            StDetTable[cnt] = row;

         StClear();
        

         //Calc();

           

    }



  
 
  //alert(JSON.stringify(DtDetTable));

 StCalc();

 var cnt = 0;
    try
    {
        cnt = StDetTable.length;
       
    }
    catch(err)
    {
        cnt=0;
    }



    var found = false;
    var i=0;
    setStoneAmt(0);
    let stamt=0;
    for (i = 0; i < cnt; i++) {
     stamt=val(stamt)+val(StDetTable[i].StAmount);
    }
setStoneAmt(stamt);

    await setDtStDetTable(StDetTable);

await Calc();

}
else
{

swal({
  title: "",
  text: "Fill All Data",
  icon: "info",
  button: "Ok"

});


//alert("Fill All Data");
}

}






async function gridAdd () {


  let slno=SaleIdRef.current;
  let ProdName=ProdNameRef.current;
  let TagNo=TagNoRef.current;
  let SubProdName=SubProdNameRef.current;
  let Pcs=val(PcsRef.current);
  let GrossWt=val(GrossWtRef.current);
  let LessWt=val(LessWtRef.current);
  let NetWt=val(NetWtRef.current);
  let Amt=val(AmtRef.current);
  let SalesWt=val(SalesWtRef.current);
  let Rate=val(RateRef.current);
  let WasteP=val(WastePRef.current);
  let WasteGrm=val(WasteGrmRef.current);
  let Wastage=val(WastageRef.current);
  let StoneAmt=val(StoneAmtRef.current);
  let HMAmt=val(HMAmtRef.current);
  let TagInfoCode=(TagInfoRef.current);
  let OthrAmt=val(OthrAmtRef.current);
  let TotAmt=val(TotAmtRef.current);
  let WasteAmt=val(WasteAmtRef.current);
  let STaxP=val(STaxPRef.current);
  let STaxAmt=val(STaxAmtRef.current);
  let HUIDNo=HUIDNoRef.current;
  let SmithCode=SmithCodeRef.current;
  let PcsRate=PcsRateRef.current;
  let SaleMode=SaleModeRef.current;
 

  if(TagMarkRef.current=="T")
  {
    if(TagNo.length<=3)
    {
    swal({
    title: "",
    text: "Please Select Tag Number",
    icon: "info",
    button: "Ok"
    });

    return;
  }
  }


if ((ProdName.length>0)&&(SubProdName.length>0)&&(NetWt>0)&&(TotAmt>0)&&(Rate>0) && (TagInfoCode.length>0))
{
    SaleDetTable=DtSaleDetTable;


    var cnt = 0;
    try
    {
        cnt = SaleDetTable.length;
       
    }
    catch(err)
    {
        cnt=0;
    }



    var found = false;
    var i=0;

    for (i = 0; i < cnt; i++) {

      

        if ((SaleDetTable[i].ID == slno)) {


          SaleDetTable[i].ProdName=ProdName;
          SaleDetTable[i].TagNo=TagNo;
          SaleDetTable[i].SubProdName=SubProdName;
          SaleDetTable[i].Pcs=Pcs;
          SaleDetTable[i].GrossWt=GrossWt;
          SaleDetTable[i].LessWt=LessWt;
          SaleDetTable[i].NetWt=NetWt;
          SaleDetTable[i].WasteP=WasteP;
          SaleDetTable[i].Wastage=Wastage;          
          SaleDetTable[i].WasteGrm=WasteGrm;
          SaleDetTable[i].Rate=Rate;
          SaleDetTable[i].SalesWt=SalesWt;
          SaleDetTable[i].StoneAmt=StoneAmt;
          SaleDetTable[i].HMAmt=HMAmt;
          SaleDetTable[i].TagInfoCode=TagInfoCode;
          SaleDetTable[i].OthrAmt=OthrAmt;
          SaleDetTable[i].TotAmt=TotAmt;
          SaleDetTable[i].Amt=Amt;
          SaleDetTable[i].WasteAmt=WasteAmt;
          SaleDetTable[i].STaxP=STaxP;
          SaleDetTable[i].STaxAmt=STaxAmt;
          SaleDetTable[i].HUIDNo=HUIDNo;
          SaleDetTable[i].SmithCode=SmithCode;
          SaleDetTable[i].PcsRate=PcsRate;
          SaleDetTable[i].SaleMode=SaleMode;
          SaleDetTable[i].StoneDetails=DtStDetTableRef.current;
          
       
    
          //det text box clear

          SalesClear();
          SaleshandleClose1();

          setDtStDetTable([]);


          await BillCalc();


            found = true;
            break;
        }
        else {


         

        if ((SaleDetTable[i].TagNo == TagNo) && (TagNo.length>0)) {
                swal({
        title: "",
        text: "This Tag Already Found",
        icon: "info",
        button: "Ok"

        });

                found = true;
                break;

            }
        }
    }


    if (found == false) {

   

         

        var row = {
            "ID": parseInt(cnt) + 1
            , "ProdName":ProdName
            , "TagNo":TagNo
            , "SubProdName":SubProdName
            , "Pcs":Pcs
            , "GrossWt":GrossWt
            , "LessWt":LessWt
            , "WasteP":WasteP
            , "WasteGrm":WasteGrm
            , "Wastage":Wastage
            , "NetWt":NetWt
            , "SalesWt":SalesWt
            , "Rate":Rate
            , "StoneAmt":StoneAmt
            , "HMAmt":HMAmt
            , "TagInfoCode":TagInfoCode
            , "OthrAmt":OthrAmt
            , "TotAmt":TotAmt
            , "Amt":Amt
            , "WasteAmt":WasteAmt
            , "STaxP":STaxP
            , "STaxAmt":STaxAmt
            , "HUIDNo":HUIDNo
            , "SmithCode":SmithCode
            , "SaleMode":SaleMode
            , "PcsRate":PcsRate
            ,"StoneDetails":DtStDetTableRef.current
        };


      
         SaleDetTable[cnt] = row;

       
       

            SalesClear();
            SaleshandleClose1();
  
            setDtStDetTable([]);

            await BillCalc();



         }
        


         //Calc();

           

    
  
  await setDtSaleDetTable(SaleDetTable);

 Calc();


}
else
{

swal({
  title: "",
  text: "Fill All Data",
  icon: "info",
  button: "Ok"

});


//alert("Fill All Data");
}

}


async function getStSubProduct()
{
  try {

  let postData = {
    "StProdCode" : StProdNameRef.current
   };
   

  const results = await apiService.postCall("otherissue/getstsubProd",postData);

  if (results != "-1") {
    setdtStSubProd(results.data[0]);
   }
} catch (error) {
     console.log(error);
   }
}



async function getSubProduct(type)
{
  try {

  let postData = {
    "ProdCode" : ProdNameRef.current
    ,"BillDate":BillDateRef.current
   };
   

  const results = await apiService.postCall("otherissue/getsubProd",postData);

  if (results != "-1") {

    if(type==0)
    {
    setSubProdName('');
    setTagNo('');
    setTagInfo('');
    setPcs(0);
    setGrossWt(0);
    setNetWt(0);
    setLessWt(0);
    setSalesWt(0);
    setWasteGrm(0);
    setWasteP(0);
    setStoneAmt(0);
    setOthrAmt(0);
    setHMAmt(0);
    setTotAmt(0);
    setSTaxP(0);
    setSTaxAmt(0);
    setHUIDNo('');
    setAmt(0);
    setRate(results.data[1]);
    setTagMark(results.data[2]);
  }

    setdtSubProd(results.data[0][0]);
   
    

   }
} catch (error) {
     console.log(error);
   }
}


async function getTagDetails()
{
  try {

  let postData = {
    "ProdCode" : ProdNameRef.current,
    "TagNo": TagNoRef.current
   };
   

  const results = await apiService.postCall("otherissue/getTagDetails",postData);

  if (results != "-1") {

    let TagDetail=results.data[0][0];
    let TagStoneDetail=results.data[1][0];

    if(TagMarkRef.current=='T')
    {

    if(TagDetail.length==0)
    {
      setTagNo('');
      setPcs(0);
      setGrossWt(0);
      setNetWt(0);
      setLessWt(0);
      setSalesWt(0);
      setWasteP(0);
      setHUIDNo('');
      setSubProdName('');
      setHMAmt(0);
      setOthrAmt(0);
      setSTaxP(3);
      setTagInfo('');

      await Calc();

      StDetTable=DtStDetTable;

      var cnt = 0;
  try
  {
      cnt = StDetTable.length;
     
  }
  catch(err)
  {
      cnt=0;
  }
      let j=0;
      for(j=0;j<cnt;j++)
      {
        if ((StDetTable[j].HeadID == SaleIdRef.current)) {
          StDetTable.splice(j, 1);
        }
      }
      setDtStDetTable(StDetTable);


      swal({
        title: "",
        text: "Tag Not Found in Stock",
        icon: "info",
        button: "Ok"
      
      });

      return;
  }

    
    

    if(TagDetail.length>0)
    {
      setTagNo(TagDetail[0].TAGNO);
      setPcs(TagDetail[0].PCS);
      setGrossWt(TagDetail[0].GROSSWT);
      setNetWt(TagDetail[0].NETWT);
      setLessWt(TagDetail[0].LESSWT);
      setSalesWt(TagDetail[0].NETWT);
      setWasteP(TagDetail[0].WastePer);
      setHUIDNo(TagDetail[0].HUID_No);
      setSubProdName(TagDetail[0].ITEMNAME);
      setHMAmt(TagDetail[0].HalMarkCharges);
      setOthrAmt(TagDetail[0].OtherCharges);
      setSTaxP(3);
      setTagInfo(TagDetail[0].TagInfoCode);
      setSaleMode(TagDetail[0].SALEMODE);
      setPcsRate(TagDetail[0].PcsRate);
      setSmithCode(TagDetail[0].SmithCode);
     
      await Calc();

  let i=0;
  StDetTable=DtStDetTable;


  for(i=0;i<TagStoneDetail.length;i++)
  {

  let id=0;
  let slno=SaleIdRef.current;
  let ProdName=TagStoneDetail[i].ProdName;
  let SubProdName=TagStoneDetail[i].ItemName;
  let RecMode=TagStoneDetail[i].StoneUnit;
  let Pcs=val(TagStoneDetail[i].StonePcs);
  let PcsRate=val(TagStoneDetail[i].StoneRate);
  let StWt=val(TagStoneDetail[i].StoneWt);
  let StAmount=val(TagStoneDetail[i].StoneAmount);


  var cnt = 0;
  try
  {
      cnt = StDetTable.length;
     
  }
  catch(err)
  {
      cnt=0;
  }

  let j=0;

for(j=0;j<cnt;j++)
{
  if ((StDetTable[j].HeadID == SaleIdRef.current)) {
    StDetTable.splice(j, 1);
  }

}

try
  {
      cnt = StDetTable.length;
     
  }
  catch(err)
  {
      cnt=0;
  }


        var row = {
        "ID": parseInt(cnt) + 1
        ,"HeadID": SaleIdRef.current
        , "ProdName":ProdName
        , "SubProdName":SubProdName
        , "RecMode":RecMode
        , "Pcs":Pcs
        , "PcsRate":PcsRate
        , "StWt":StWt
        , "StAmount":StAmount
    };

    StDetTable[cnt] = row;

    }
    setDtStDetTable(StDetTable);
  }
 }
}

} catch (error) {
     console.log(error);
   }
}




  async function getLookup(){
	 try {		
				 
		let postData = {
      "ProdCode" : 0
    };
		
    const results = await apiService.postCall("otherissue/Lookup",postData);

	 if (results != "-1") {

    setdtStProd(results.data[0][0]);
    setdtStSubProd(results.data[1][0]);
    setdtProd(results.data[2][0]);
    setdtSubProd(results.data[3][0]);
    setdtTagInfo(results.data[4][0]);
   
  
    let StRecMode=[
      {"RecMode":" "},
      {"RecMode":"P"},
      {"RecMode":"W"},
      {"RecMode":"C"}
    ]
    setDtStRecMode(StRecMode);
  
    let Relation=[
      {"Relation":"Own"},
      {"Relation":"Father"},
      {"Relation":"Mother"},
      {"Relation":"Son"},
      {"Relation":"Daughter"},
      {"Relation":"Husband"},
      {"Relation":"Wife"},
      {"Relation":"Brother"},
      {"Relation":"Sister"},
      {"Relation":"Grandfather"},
      {"Relation":"Grandmother"},
      {"Relation":"Grandson"},
      {"Relation":"Granddaughter"},
      {"Relation":"Uncle"},
      {"Relation":"Aunt"},
      {"Relation":"Son-in-law"},
      {"Relation":"Daughter-in-law"},
      {"Relation":"Cousins"},
      {"Relation":"Friend"},
      {"Relation":"Others"}
   
    ]

  
    setdtCustRelation(Relation);




      }

    } catch (error) {
      console.log(error);
    }
}

 
  const navigate = useNavigate();
  const BackToList = () => {
  navigate('../dashboard/table/sales/otherissue/list');
  };


  
  return (
    <>  
    

      <Row >
        <Card>
          <Card.Header className="d-flex ">
            <div className="header-title">
             </div>
          </Card.Header>
          <Card.Body className='BillScreen'> 
            <div className='container billcontainer'>
              <div className='container-fluid'>

              <div className='row'>
              </div>

                <div className='row'>
                  <div className='col-lg-8'>
                       
                        <div className='row py-2'>
                          <div className='col-md-4'>
                            <Form.Label>Issue No</Form.Label>
                            <Form.Control type="text" Readonly="Readonly" id="txtBillNo" placeholder="" value={BillNo}  />
                          </div>
                         
                          <div className='col-md-4'>
                            <Form.Label>Date</Form.Label>
                            <Form.Control type="date" Readonly="Readonly" id="txtBillDate" placeholder="" value={BillDate} onChange={(e)=>setBillDate(e.target.value)} />
                          </div>
						  
                       
</div>
</div>


                  </div>
                 
                  <div className='row'>
                  <div className='col-lg-12'>
                    <div className='col-md-12 col-lg-12 col-sm-12 col-xs-12'>
                      <div className='container-fluid py-4 '>
                        <div className='row py-2'>

                       
   
    
    <div className="table-responsive mt-4" >
			 
      
       	   
       <Table striped id="basic-table" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
            <th>Edit</th>
             <th>Product</th>
             <th>Tag No</th>
             <th>Sub Product</th>                 
             <th>Pcs</th>
             <th>Gross Wt</th>
             <th>Net Wt</th>
             <th>Waste</th>  
             <th>HM Charges</th>  
             <th>Stone Amount</th>  
             <th>Other Charges</th>  
             <th>Net Amount</th>  
             
   <th>Delete</th>					  
           </tr>
         </thead>
         <tbody>
         {DtSaleDetTable.map((item) => (
           <tr>
              <td>
    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>SalesgridEdit(item.ID)}  >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                       <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
   </td>

             <td>{item.ProdName}</td>
             <td>{item.TagNo}</td>
             <td>{item.SubProdName}</td>
             <td>{item.Pcs}</td>                 
             <td>{item.GrossWt}</td>
             <td>{item.NetWt}</td>
             <td>{item.Wastage}</td>
             <td>{item.HMAmt}</td>  
             <td>{item.StoneAmt} </td>  
             <td>{item.OthrAmt}</td>  
             <td>{item.TotAmt}</td>  
            
             
<td>
  <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete" to="#" onClick={(e)=>SalegridRemove(item.ID)} >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                       <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
 </td>
           </tr>
   )
   )
    }     
         </tbody>
       </Table>
<div className="EntryPan">

<Link className="btn btn-sm btn-icon text-primary" data-bs-toggle="tooltip" title="Add" to="#"  onClick=
                              {
                                (e) => {
                              setSaleId('');
                              SaleshandleShow1();
                                }
                                } >
                   <span className="btn-inner">
                   <svg class="icon-32" width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.0001 8.32739V15.6537" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M15.6668 11.9904H8.3335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>                            
                   </span>
                 </Link>




</div>



                         
                         
     </div>
     
     

     

   
      <div className='row'>

      
       	   
       <div className='col-md-3' hidden='true'>
      <Form.Label><span className='spanLink' onClick={CustOpen}>Mobile No</span></Form.Label>
      <Form.Control type="text" Readonly="Readonly" value={Mobile} placeholder="" className='txtReadOnly'  />
    </div>
    <div className='col-md-6'  hidden='true'>
      <Form.Label>Customer Name</Form.Label>
      <Form.Control type="text" Readonly="Readonly"  placeholder=""  value={CustName}  className='txtReadOnly' />
      <Form.Control type="hidden" Readonly="Readonly" value={CustId}  placeholder=""   />
    </div>



<div className='col-lg-12' hidden={ShowCustBillDetail} id="divBillingName">
<div className='row'>
<div className='col-lg-4'>
<div className='col-md-12'>
      <Form.Label>Billing Name</Form.Label>
      <Form.Control type="text" value={CustBillName} onChange={(e)=>setCustBillName(e.target.value)} placeholder=""   />
    </div>

    <div className='col-md-12'>
      <Form.Label>Address</Form.Label>
      <Form.Control type="text" value={Address1} onChange={(e)=>setAddress1(e.target.value)} placeholder=""   />
    </div>
    <div className='col-md-12'>
      <Form.Label></Form.Label>
      <Form.Control type="text" value={Address2} onChange={(e)=>setAddress2(e.target.value)} placeholder=""   />
    </div>
    <div className='col-md-12'>
      <Form.Label></Form.Label>
      <Form.Control type="text" value={Address3} onChange={(e)=>setAddress3(e.target.value)} placeholder=""   />
    </div>
</div>
  
<div className='col-lg-4'>
<div className='col-md-12'>
      <Form.Label>Area</Form.Label>
      <Form.Control type="text" value={Area} onChange={(e)=>setArea(e.target.value)} placeholder=""   />
    </div>

    <div className='col-md-12'>
      <Form.Label>City</Form.Label>
      <Form.Control type="text" value={City} onChange={(e)=>setCity(e.target.value)} placeholder=""   />
    </div>
    <div className='col-md-12'>
      <Form.Label>Pincode</Form.Label>
      <Form.Control type="text" value={PinCode} onChange={(e)=>setPinCode(e.target.value)} placeholder=""   />
    </div>
    <div className='col-md-12'>
      <Form.Label>Email Id</Form.Label>
      <Form.Control type="text" value={EmailId} onChange={(e)=>setEmailId(e.target.value)} placeholder=""   />
    </div>
</div>



<div className='col-lg-4'>
<div className='col-md-12'>
      <Form.Label>Adhar No</Form.Label>
      <Form.Control type="text" value={AdharNo} onChange={(e)=>setAdharNo(e.target.value)} placeholder=""   />
    </div>

    <div className='col-md-12'>
      <Form.Label>Pan No</Form.Label>
      <Form.Control type="text" value={PanNo} onChange={(e)=>setPanNo(e.target.value)} placeholder=""   />
    </div>
    
   
</div>


</div>
</div>


<div className='col-lg-2'>
    <div className='col-md-12'>
      <Form.Label>Issue Wt</Form.Label>
      <Form.Control type="number" Readonly="Readonly" value={TSalesWt} placeholder="" className='txtReadOnly'   />
    </div>

    <div className='col-md-12'>
      <Form.Label>Issue Amount</Form.Label>
      <Form.Control type="number" Readonly="Readonly" value={SalesAmount}  placeholder=""  className='txtReadOnly'   />
    </div>
        </div>  
     </div>

  
                          </div>
                      </div>
                    </div>
                  </div>
              </div>
              </div>
             	
              <Modal show={Salesshow1} className=".modal-xl" id="EntryModal4" >
                  <Modal.Header>
                    <Modal.Title>Issue Product Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                            <div className='col-md-4'>

        <Form.Label>Product</Form.Label>
         <Select className="form-select-search" 
       options={dtProd}
       value={dtProd.filter(function(option) {
        return option.value === ProdName;
      })}
      onChange=
      {
        (e) => {
      setProdName(e.value);
      getSubProduct(0);
        }
        }
       disabled={false}>
       </Select>
       

     
      </div>

      <div className='col-md-2'>
                              <Form.Label>Tag</Form.Label>
                              <Form.Control type="text" value={TagNo} onBlur={getTagDetails} onChange={(e) => {setTagNo(e.target.value);}}  placeholder="" />
                        
                            </div>

<div className='col-md-4'>
        <Form.Label>Sub Product</Form.Label>

        <Select className="form-select-search" id="txtStProductName" 
       options={dtSubProd}
       value={dtSubProd.filter(function(option) {
        return option.value === SubProdName;
      })}
      onChange=
      {
        (e) => {
      setSubProdName(e.value);
        }
        }
       disabled={false}>
       </Select>
       

      </div>
                    
      <div className='col-md-2'>
                              <Form.Label>Tag Info</Form.Label>
                              <select className="form-select"  value={TagInfo}
                              onChange=
                              {
                                (e) => {
                              setTagInfo(e.target.value);
                              StCalc();
                                }
                                }
                                 >
                              { 
                              dtTagInfo.map(
                              (item)=>(
                              <option value={item.value}>{item.label}</option>
                              )
                              )
                              }
                             </select>

                            </div>
                    
                
                        
                            <div className='col-md-2'>
                              <Form.Label>Pcs</Form.Label>
                            <Form.Control type="text" value={Pcs}  onChange={(e) => {setPcs(e.target.value);}} onKeyUp={Calc}    placeholder="" />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Gross Wt</Form.Label>
                            <Form.Control type="text"value={GrossWt}  onChange={(e) => {setGrossWt(e.target.value);}} onKeyUp={Calc}  placeholder=""  />
                            </div>
                            
                           

                            <div className='col-md-2'>
                              <Form.Label>Less Wt</Form.Label>
                            <Form.Control type="text" value={LessWt}  onChange={(e) => {setLessWt(e.target.value);}} onKeyUp={Calc}  placeholder="" />
                            </div>

                            
                           
                           
                            <div className='col-md-2'>
                              <Form.Label>Net Wt</Form.Label>
                            <Form.Control type="text" value={NetWt}  onChange={(e) => {setNetWt(e.target.value);}}  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Sales Wt</Form.Label>
                            <Form.Control type="text" value={SalesWt}  onChange={(e) => {setSalesWt(e.target.value);}}   Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>

                            <div className='col-md-2'>
                              <Form.Label>Rate</Form.Label>
                            <Form.Control type="text" value={Rate}  onChange={(e) => {setRate(e.target.value);}} onKeyUp={Calc} placeholder=""   />
                            </div>


                            <div className='col-md-2'>
                              <Form.Label>Amount</Form.Label>
                            <Form.Control type="text" value={Amt}  onChange={(e) => {setAmt(e.target.value);}}  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>

                            <div className='col-md-2'>
                              <Form.Label>Waste %</Form.Label>
                            <Form.Control type="text" value={WasteP}  onChange={(e) => {setWasteP(e.target.value);}}  onKeyUp={Calc} placeholder=""   />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Waste/Grm</Form.Label>
                            <Form.Control type="text" value={WasteGrm}  onChange={(e) => {setWasteGrm(e.target.value);}}  onKeyUp={Calc} placeholder=""   />
                            </div>
                            
                            
                            <div className='col-md-2'>
                              <Form.Label>Wasteage</Form.Label>
                            <Form.Control type="text" value={Wastage}  onChange={(e) => {setWastage(e.target.value);}}  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>
                           
                            <div className='col-md-2'>
                              <Form.Label>Waste Amount</Form.Label>
                            <Form.Control type="text" value={WasteAmt}  onChange={(e) => {setWasteAmt(e.target.value);}}  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label><span className='spanLink' onClick={OpenStoneScreen}>Stone Amt</span></Form.Label>
                            <Form.Control type="text" value={StoneAmt}  onChange={(e) => {setStoneAmt(e.target.value);}}  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            <Form.Control type="hidden" id="txtStonePcs"  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                         
                            </div>

                            <div className='col-md-2'>
                              <Form.Label>Othr.Chrgs</Form.Label>
                            <Form.Control type="text" value={OthrAmt}  onChange={(e) => {setOthrAmt(e.target.value);}} onKeyUp={Calc} placeholder=""   />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Hallmark</Form.Label>
                            <Form.Control type="text" value={HMAmt}  onChange={(e) => {setHMAmt(e.target.value);}} onKeyUp={Calc}  placeholder=""   />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Tot.Amt</Form.Label>
                            <Form.Control type="text" value={TotAmt}  onChange={(e) => {setTotAmt(e.target.value);}}  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>
                            
                            <div className='col-md-2'>
                              <Form.Label>Tax %</Form.Label>
                            <Form.Control type="text" value={STaxP}  onChange={(e) => {setSTaxP(e.target.value);}} onKeyUp={Calc}  placeholder=""  />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Tax </Form.Label>
                            <Form.Control type="text" value={STaxAmt}  onChange={(e) => {setSTaxAmt(e.target.value);}}  Readonly="Readonly" placeholder=""  className="txtReadOnly" />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>HUID No </Form.Label>
                            <Form.Control type="text" value={HUIDNo}  onChange={(e) => {setHUIDNo(e.target.value);}}  placeholder="" />
                            </div>
                            

</div>
</div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton" id="cmdDetSave"  variant="btn btn-primary" onClick={gridAdd}>OK</Button>
					<Button type="button" className="detbutton" id="cmdDetNew" variant="btn btn-primary" onClick={SalesClear}>Cancel</Button>
                       </div>
                  </Modal.Body>
                </Modal>
				
          
                <Modal show={Stoneshow1} className=".modal-xl " id="EntryModal3"   >
                  <Modal.Header>
                    <Modal.Title>Stone Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                      <div className='col-md-6'>

                      <Form.Control type="hidden" id="txtStWt" value={StId} onChange=
                              {
                                (e) => {
                              setStId(e.target.value);
                                }
                                }  placeholder=""  />

                              <Form.Label>Stone Product</Form.Label>
                               <Select className="form-select-search" id="txtStProductName" 
                             options={dtStProd}
                             value={dtStProd.filter(function(option) {
                              return option.value === StProdName;
                            })}
                            onChange=
                            {
                              (e) => {
                            setStProdName(e.value);
                            getStSubProduct();
                              }
                              }
                             disabled={false}>
              				       </Select>
                             

                           
                            </div>
                    


                     <div className='col-md-6'>
                              <Form.Label>Stone Sub Product</Form.Label>

                              <Select className="form-select-search" id="txtStProductName" 
                             options={dtStSubProd}
                             value={dtStSubProd.filter(function(option) {
                              return option.value === StSubProdName;
                            })}
                            onChange=
                            {
                              (e) => {
                            setStSubProdName(e.value);
                              }
                              }
                             disabled={false}>
              				       </Select>
                             

                            </div>
                
                            <div className='col-md-2'>
                              <Form.Label>Rec Mode</Form.Label>
                              <select className="form-select" id="txtStRecMode" 
                              onChange=
                              {
                                (e) => {
                              setStRecMode(e.target.value);
                              StCalc();
                                }
                                }
                                 >
                              { 
                              DtStRecMode.map(
                              (item)=>(
                              <option value={item.RecMode}>{item.RecMode}</option>
                              )
                              )
                              }
                             </select>

                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Pcs</Form.Label>
                            <Form.Control type="number" id="txtStPcs"   value={StPcs} 
                            onChange=
                            {
                              (e) => {
                            setStPcs(e.target.value);
                            StCalc();
                              }
                              }
                            placeholder="" />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Weight</Form.Label>
                            <Form.Control type="number" id="txtStWt" value={StWeight} onChange=
                              {
                                (e) => {
                              setStWeight(e.target.value);
                              StCalc();
                                }
                                }  placeholder=""  />
                            </div>
                            <div className='col-md-2'>
                              <Form.Label>Rate</Form.Label>
                            <Form.Control type="number" id="txtStPcsRate" value={StRate}
                            onChange=
                            {
                              (e) => {
                            setStRate(e.target.value);
                            StCalc();
                              }
                              }
                                  placeholder="" />
                            </div>
                           
                            <div className='col-md-2'>
                              <Form.Label>Amount</Form.Label>
                            <Form.Control type="number" id="txtStAmount" value={StAmount}
                            onChange=
                            {
                              (e) => {
                            setStAmount(e.target.value);
                              }
                              } Readonly="Readonly" placeholder="" className="txtReadOnly" />
                            </div>

                            <div style={{ "text-align": 'center' }}>
                    <Button type="button" className="detbutton" id="cmdStoneSave"  variant="btn btn-primary" onClick={StgridAdd}>Add to Table</Button>
					              </div>


                       <div className="table-responsive mt-4" >
			 
				
       <Table striped id="basic-table" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
           <th>Edit</th>
             <th>Product</th>
             <th>Sub Product</th>
             <th>Mode</th>   
             <th>Pcs</th>              
             <th>Rate</th>
             <th>Weight</th>
             <th>Amount</th>

             
            <th>Delete</th>					  
           </tr>
         </thead>
         <tbody>
         {DtStDetTable.map((item) => (
           <tr >
              <td>
    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>StgridEdit(item.ID)} >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                       <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
   </td>

             <td>{item.ProdName}</td>
             <td>{item.SubProdName}</td>
             <td>{item.RecMode}</td>
             <td>{item.Pcs}</td>
             <td>{item.PcsRate}</td>
             <td>{item.StWt}</td>
             <td>{item.StAmount}</td> 
             
             
<td>
  <Link className="btn btn-sm btn-icon text-danger" data-bs-toggle="tooltip" title="Delete" to="#" onClick={(e)=>StgridRemove(0)}>
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor">
                       <path d="M19.3248 9.46826C19.3248 9.46826 18.7818 16.2033 18.4668 19.0403C18.3168 20.3953 17.4798 21.1893 16.1088 21.2143C13.4998 21.2613 10.8878 21.2643 8.27979 21.2093C6.96079 21.1823 6.13779 20.3783 5.99079 19.0473C5.67379 16.1853 5.13379 9.46826 5.13379 9.46826" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M20.708 6.23975H3.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M17.4406 6.23973C16.6556 6.23973 15.9796 5.68473 15.8256 4.91573L15.5826 3.69973C15.4326 3.13873 14.9246 2.75073 14.3456 2.75073H10.1126C9.53358 2.75073 9.02558 3.13873 8.87558 3.69973L8.63258 4.91573C8.47858 5.68473 7.80258 6.23973 7.01758 6.23973" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
 </td>
           </tr>
            
                )
             )
              }    
         </tbody>
       </Table>
<div className="EntryPan">

<Link className="btn btn-sm btn-icon text-primary" data-bs-toggle="tooltip" title="Delete" to="#" onClick={StClear}>
                   <span className="btn-inner">
                   <svg class="icon-32" width="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.0001 8.32739V15.6537" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                    
                    <path d="M15.6668 11.9904H8.3335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                    
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>                            
                   </span>
                 </Link>

</div>
     </div>

     <div style={{ "direction": 'rtl' }}>
  
                    <Button type="button" className="detbutton" id="cmdStoneSave"  variant="btn btn-primary" onClick={CloseStoneScreen}>OK</Button>
                    <Button type="button" className="detbutton" id="cmdStoneNew" variant="btn btn-primary" onClick={CloseStoneScreen}>Cancel</Button>
  </div>

</div>
</div>

                    </Form.Group>
                   
                  </Modal.Body>
                </Modal>
				
				
        
                <Modal show={Custshow1} className=" .modal-xl" onHide={CusthandleClose1} id="EntryModal1" >
                  <Modal.Header closeButton>
                    <Modal.Title>Customer Details</Modal.Title>
                  </Modal.Header>
                  <Modal.Body >
                    <Form.Group className="mb-12" >

                    <div className="table-responsive mt-4" id="EntryModalCust" >
			 
       <div className="row">
                    <div className='col-md-11'>
                              <Form.Control type="text"  value={CustSearchTxt}     onChange=
                            {
                              (e) => {
                            setCustSearchTxt(e.target.value);
                            GetCustList(e.target.value);
                              }
                              }  placeholder="Search (Minimum 5 Letters)" />
</div>
<div className='col-md-1'>
                <Link className="btn btn-sm btn-icon text-primary" data-bs-toggle="tooltip" title="Add" to="#" onClick= {
                              (e) => {
                            setxMobile(CustSearchTxtRef.current);
                            setxCustId(0);
                            setxCustName('');
                            setxAddress1('');
                            setxAddress2('');
                            setxAddress3('');
                            setxCity('');
                            setxPinCode('');
                            setxArea('');
                            setxPhoneNo('');
                            setxEmailId('');

                            CustEntryhandleShow1();
                              }
                              } >
                   <span className="btn-inner">
                   <svg class="icon-32" width="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12.0001 8.32739V15.6537" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path d="M15.6668 11.9904H8.3335" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6857 2H7.31429C4.04762 2 2 4.31208 2 7.58516V16.4148C2 19.6879 4.0381 22 7.31429 22H16.6857C19.9619 22 22 19.6879 22 16.4148V7.58516C22 4.31208 19.9619 2 16.6857 2Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
                    </svg>                            
                   </span>
                 </Link>

                      </div>
                      </div>
                      
       <Table striped id="basic-table" className="table-striped mb-0" role="grid">
         <thead>
           <tr>
           <th>Select</th>   
           <th>Customer Name</th>
             <th>Mobile No</th>
             <th>Area</th>
             <th>City</th>   
             <th>Edit</th>
         
           </tr>
         </thead>
         <tbody>
         {dtCust.map((item) => (
           <tr >
             
             <td>

                                  

    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>CustSelect(item.CustId)} >
                   <span className="btn-inner">

                   <svg class="icon-32" width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M16.3345 2.75024H7.66549C4.64449 2.75024 2.75049 4.88924 2.75049 7.91624V16.0842C2.75049 19.1112 4.63549 21.2502 7.66549 21.2502H16.3335C19.3645 21.2502 21.2505 19.1112 21.2505 16.0842V7.91624C21.2505 4.88924 19.3645 2.75024 16.3345 2.75024Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                    
              <path d="M8.43994 12.0002L10.8139 14.3732L15.5599 9.6272" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>                                
              </svg>  

                     
                   </span>
                 </Link>
   </td>
             <td>{item.CustomerName}</td>
             <td>{item.Mobile}</td>
             <td>{item.Area}</td>
             <td>{item.City}</td>
             
           

             <td>
    <Link className="btn btn-sm btn-icon text-primary flex-end" data-bs-toggle="tooltip" title="Edit" to="#" onClick={(e)=>CustEdit(item.CustId)} >
                   <span className="btn-inner">
                     <svg width="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                       <path d="M11.4925 2.78906H7.75349C4.67849 2.78906 2.75049 4.96606 2.75049 8.04806V16.3621C2.75049 19.4441 4.66949 21.6211 7.75349 21.6211H16.5775C19.6625 21.6211 21.5815 19.4441 21.5815 16.3621V12.3341" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path fillRule="evenodd" clipRule="evenodd" d="M8.82812 10.921L16.3011 3.44799C17.2321 2.51799 18.7411 2.51799 19.6721 3.44799L20.8891 4.66499C21.8201 5.59599 21.8201 7.10599 20.8891 8.03599L13.3801 15.545C12.9731 15.952 12.4211 16.181 11.8451 16.181H8.09912L8.19312 12.401C8.20712 11.845 8.43412 11.315 8.82812 10.921Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                       <path d="M15.1655 4.60254L19.7315 9.16854" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                     </svg>
                   </span>
                 </Link>
   </td>

             

           </tr>
            
            )
            )
             }     
         </tbody>
       </Table>

     </div>


				
                    </Form.Group>
                   
                  </Modal.Body>
                </Modal>



                <Modal show={CustEntryshow1}  className=".modal-xl" id="EntryModal3" >
                  <Modal.Header >
                    <Modal.Title>Customer Detail</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Form.Group className="mb-12" >
					<div className='container-fluid py-12 '>
                        <div className='row py-2'>
                     
                       <div className='col-md-4'>

                        <div className='col-md-12'>
                              <Form.Label>Customer Name</Form.Label>
                              <Form.Control type="text"   value={xCustName} onChange=
                            {
                              (e) => {
                            setxCustName(e.target.value);
                              }
                              }  placeholder="" />
                        </div>


                            <div className='col-md-12'>
                              <Form.Label>Mobile No</Form.Label>
                              <Form.Control type="text"  value={xMobile} onChange=
                            {
                              (e) => {
                            setxMobile(e.target.value);
                              }}   placeholder="" />
                        
                            </div>

                              <div className='col-md-12'>
                              <Form.Label>Address</Form.Label>
                              <Form.Control type="text"  value={xAddress1} onChange=
                            {
                              (e) => {
                            setxAddress1(e.target.value);
                              }}   placeholder="" />
                              </div>
                              <div className='col-md-12'>
                              <Form.Label></Form.Label>
                         <Form.Control type="text"  value={xAddress2} onChange=
                            {
                              (e) => {
                            setxAddress2(e.target.value);
                              }}   placeholder="" />
                                         </div>
                              <div className='col-md-12'>
                              <Form.Label></Form.Label>
                               <Form.Control type="text"  value={xAddress3} onChange=
                            {
                              (e) => {
                            setxAddress3(e.target.value);
                              }}   placeholder="" />

                            </div>
                            
                            </div>

                            <div className='col-md-4'>
                            <div className='col-md-12'>
                              <Form.Label>Area</Form.Label>
                              <Form.Control type="text"  value={xArea} onChange=
                            {
                              (e) => {
                            setxArea(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>City</Form.Label>
                              <Form.Control type="text"  value={xCity} onChange=
                            {
                              (e) => {
                            setxCity(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Pincode</Form.Label>
                              <Form.Control type="text"  value={xPinCode} onChange=
                            {
                              (e) => {
                            setxPinCode(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Phone</Form.Label>
                              <Form.Control type="text"  value={xPhoneNo} onChange=
                            {
                              (e) => {
                            setxPhoneNo(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Email Id</Form.Label>
                              <Form.Control type="text"  value={xEmailId} onChange=
                            {
                              (e) => {
                            setxEmailId(e.target.value);
                              }}   placeholder="" />
                        
                            </div>

                              </div>


                              <div className='col-md-4'>
                            <div className='col-md-12'>
                              <Form.Label>Adhar No</Form.Label>
                              <Form.Control type="text"  value={xAdharNo} onChange=
                            {
                              (e) => {
                            setxAdharNo(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Pan No</Form.Label>
                              <Form.Control type="text"  value={xPanNo} onChange=
                            {
                              (e) => {
                            setxPanNo(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Ref. Mobile No</Form.Label>
                              <Form.Control type="text"  value={xRefMobileNo} onChange=
                            {
                              (e) => {
                            setxRefMobileNo(e.target.value);
                            getxRefName();
                           
                              }} placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Ref. Name</Form.Label>
                              <Form.Control type="text"  value={xRefCustName} Readonly="readonly" className="txtReadOnly" onChange=
                            {
                              (e) => {
                            setxRefCustName(e.target.value);
                              }}   placeholder="" />
                        
                            </div>
                            <div className='col-md-12'>
                              <Form.Label>Ref. Relation</Form.Label>
                              <select className="form-select"  value={xRefRelation}
                              onChange=
                              {
                                (e) => {
                              setxRefRelation(e.target.value);
                                }
                                }
                                 >
                              { 
                              dtCustRelation.map(
                              (item)=>(
                              <option value={item.Relation}>{item.Relation}</option>
                              )
                              )
                              }
                             </select>

</div>

                              </div>
</div>
</div>

                    </Form.Group>
                    <div style={{ "direction": 'rtl' }}>
                    <Button type="button" className="detbutton"  variant="btn btn-primary" onClick={CustSave}>OK</Button>
					<Button type="button" className="detbutton"  variant="btn btn-primary" onClick={CustEntryClose}>Cancel</Button>
                       </div>
                  </Modal.Body>
                </Modal>
                
              <div className='pt-2' style={{ direction: 'rtl' }} >
                <Form.Group className="form-group">
                  <Button type="button" variant='btn btn-primary' >
                    <i className="btn-inner">
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-printer" viewBox="0 0 16 16">
                        <path d="M2.5 8a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z" />
                        <path d="M5 1a2 2 0 0 0-2 2v2H2a2 2 0 0 0-2 2v3a2 2 0 0 0 2 2h1v1a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2v-1h1a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2h-1V3a2 2 0 0 0-2-2H5zM4 3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v2H4V3zm1 5a2 2 0 0 0-2 2v1H2a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1v-1a2 2 0 0 0-2-2H5zm7 2v3a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1v-3a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1z" />
                      </svg>
                    </i>
                    <span>Print</span>
                  </Button>{' '}
                  <Button type="button" variant="btn btn-danger" onClick={BackToList}>cancel</Button> {' '}
                  <Button type="button" variant="btn btn-primary" disabled={btndisabled} onClick={Save}>{SaveButtonText}</Button>
                </Form.Group>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Row >
    </>
  );
};

export default TableData;
